import _classCallCheck from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
Copyright 2021 Splunk Inc.

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/
import { InstrumentationBase } from '@opentelemetry/instrumentation';
import { VERSION } from './version';
var MODULE_NAME = 'splunk-visibility';
export var SplunkPageVisibilityInstrumentation = /*#__PURE__*/function (_InstrumentationBase) {
  _inherits(SplunkPageVisibilityInstrumentation, _InstrumentationBase);

  var _super = _createSuper(SplunkPageVisibilityInstrumentation);

  function SplunkPageVisibilityInstrumentation() {
    var _this;

    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, SplunkPageVisibilityInstrumentation);

    _this = _super.call(this, MODULE_NAME, VERSION, Object.assign({}, config));
    _this.unloading = false;
    return _this;
  }

  _createClass(SplunkPageVisibilityInstrumentation, [{
    key: "init",
    value: function init() {}
  }, {
    key: "enable",
    value: function enable() {
      var _this2 = this;

      if (document.hidden) {
        this._createSpan(document.hidden);
      }

      this.unloadListener = function () {
        _this2.unloading = true;
      };

      this.visibilityListener = function () {
        //ignore when page is unloading as it is expected then
        if (!_this2.unloading) {
          _this2._createSpan(document.hidden);
        }
      };

      window.addEventListener('beforeunload', this.unloadListener);
      window.addEventListener('visibilitychange', this.visibilityListener);
    }
  }, {
    key: "disable",
    value: function disable() {
      window.removeEventListener('beforeunload', this.unloadListener);
      window.removeEventListener('visibilitychange', this.visibilityListener);
    }
  }, {
    key: "_createSpan",
    value: function _createSpan(hidden) {
      var now = Date.now();
      var span = this.tracer.startSpan('visibility', {
        startTime: now
      });
      span.setAttribute('hidden', hidden);
      span.end(now);
    }
  }]);

  return SplunkPageVisibilityInstrumentation;
}(InstrumentationBase);